// Shared Lenis singleton so components (e.g. the work lightbox)
// can pause momentum scrolling without owning the instance.
let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const stopLenis = () => lenis?.stop();
export const startLenis = () => lenis?.start();
